import React from "react";

import { OutlinedInput } from "@material-ui/core";

import style from "../style.module.css";

export const DefaultSection = (props) => {
    // const {
    //     state,
    //     initialState,
    //     setField,
    //     errorState,
    //     setErrorMessage,
    //     debounce,
    //     checkSubdomainValid,
    //     errorHandlerToggle,
    //     enableError,
    // } = props;

    return (
        <>
            <div className={style.fieldContainer}>
                <div className={style.label}>Default Field title</div>
                <div className={style.field}>
                    <OutlinedInput className={style.input} />
                </div>
            </div>
        </>
    );
};
